/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */
// var app = window.app != null ? window.app : {};

var getConfigParameter, log, logping, _;
if (typeof require === "function") {
	var logging = require("../utils/log");
	log = logging.log;
	logping = logging.logping;

	NetworkStatus = require("./NetworkStatus");
	var c = require("../config");
	getConfigParameter = c.getConfigParameter;

	_ = require('lodash');
}

/**
 * The connection bundling the plain websocket handling
 * @type {{connect, sendMessage, close}}
 */
function OutBuffer(communication) {

	/** The outgoing messages not yet acked by the server. */
	var outQueue = [];
	/** timestamps of all messages that have been sent already but not yet acked */
	var lastSendTimestamps = {};
	/** ID of the next message to put into the queue */
	var lastSentId = -1;
	/** ID of the next message to write from the queue */
	var nextMessageToWrite = 0;

	var resendThreshold = getConfigParameter("websocketResentThreshold");

	var self = this;

	/**
	 * add the message to the OutBuffer
	 * if not authenticated, the message silently dropped if not allowed to send before authentication is completed
	 *
	 * @param messageType
	 * @param encodedMessage
	 * @return number - the messageId assigned to the message or -1 if message was not queued
	 */
	function addMessage(messageType, encodedMessage) {
		// before we are authenticated, only a few messages are allowed
		if (communication.isAuthenticated() ||
				communication.isPreAuthenticationAllowedMessageType(messageType)) {
			lastSentId++;
			log.trace("Appended message to the OutBuffer ", messageType, " [", lastSentId, "]");
			outQueue.push({"id": lastSentId, "payload": encodedMessage});
			return lastSentId;
		} else {
			log.debug("Message ", messageType, " not appended to OutBuffer as we are not yet authenticated");
			return -1;
		}
	}

	/**
	 * remove all messages in the buffer with ID up to ackedMsgId
	 *
	 * @param ackedMsgId
	 */
	function removeAckedMessages(ackedMsgId) {
		outQueue = _.reject(outQueue.slice(0), function (elem) {
			var remove = elem.id <= ackedMsgId;
			if (remove) {
				// also remove from lastSendTimestamps
				logping.trace("removing message ", elem.id, " from OutBuffer");
				delete lastSendTimestamps[elem.id];
			}
			return remove;
		});
	}

	/**
	 * return all messages that should be (re)written to the connection
	 */
	function retrieveMessagesToWrite() {
		var now = Date.now();
		rewindIfNecessary(now); // check if there are old messages that should be resent
		// idea: Anzahl messages begrenzen, damit nicht zu viel auf einmal verschickt wird ... wie viele max gleichzeitig?
		var messagesToWrite = _.filter(outQueue.slice(0), function (elem) {
			var write = elem.id >= nextMessageToWrite;
			if (write) {
				lastSendTimestamps[elem.id] = now; // remember when this message was sent
			}
			return write;
		});
		if (messagesToWrite.length > 0) {
			// update the nextMessageToWrite pointer
			nextMessageToWrite += messagesToWrite.length;
			logping.trace("next message to write = ", nextMessageToWrite);
		}
		return messagesToWrite;
	}

	/**
	 * check if there are messages that should be resent
	 * (ack not within threshold)
	 *
	 * @param now (integer) timestamp
	 * @returns {boolean} true if rewinded
	 */
	function rewindIfNecessary(now) {
		if (outQueue.length === 0) { return false; }
		// get sent timestamp of first message in queue (the oldest that hasn't been acked)
		var oldestSentTimestamp = lastSendTimestamps[outQueue[0].id]; // might be undefined if not yet sent
		if (oldestSentTimestamp && (now - oldestSentTimestamp) > resendThreshold) {
			logping.debug(">>>> We have to rewind - last send timestamp of first out message is too long ago, id: ",
			          outQueue[0].id);
			rewindToFirst();
			return true;
		}
		return false;
	}

	/**
	 * called if we want to resend messages to the server that haven't been acked yet
	 */
	function rewindToFirst() {
		// set the nextMessageToWrite to the first ID in the queue
		nextMessageToWrite = outQueue[0].id;
		logping.debug("rewind out buffer to message id ", nextMessageToWrite);
	}

	/**
	 * well, delete all messages in the OutBuffer
	 */
	function clear() {
		outQueue = [];
		lastSendTimestamps = {};
		lastSentId = -1;
		nextMessageToWrite = 0;
		logping.debug("Cleared OutBuffer");
	}

	function getStatus() {
		return {
			outQueue: outQueue,
			lastSendTimestamps: lastSendTimestamps,
			lastSentId: lastSentId,
			nextMessageToWrite: nextMessageToWrite,
			resendThreshold: resendThreshold,
			self: self
		};
	}

	// Public API
	return {
		addMessage: addMessage,
		removeAckedMessages: removeAckedMessages,
		retrieveMessagesToWrite: retrieveMessagesToWrite,
		clear: clear,
		getStatus: getStatus // for debugging
	}
}

if (typeof module === "object") {
	module.exports = OutBuffer;
}
